import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faVideo,
    faClipboardList,
    faStickyNote,
    faClipboardCheck
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { API_URL, token } from "../config";
import { expDate } from "../Components/ExpDate";
import Swal from "sweetalert2";
import { ClipLoader } from 'react-spinners';
import { getCurrentDate } from "../Components/DateFunction";

const StudentHome = () => {

    const navigate = useNavigate();
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [moduleId] = useState(localStorage.getItem('moduleId'));
    const [courseId] = useState(localStorage.getItem('levelId'));
    const [userId] = useState(localStorage.getItem('userId'));
    const [price] = useState(localStorage.getItem('price'));
    const [promo] = useState(localStorage.getItem('PROMO'));
    const [freeTrial, setFreeTrial] = useState(localStorage.getItem('freeTrial') === 'true' ? true : false); // Convert to boolean
    const [lessonCount, setLessonCount] = useState('');
    const [assignmentCount, setAssignmentCount] = useState('');
    const [noteCount, setNoteCount] = useState('');
    const [resultCount, setResultCount] = useState('');
    const [feedbackCount, setFeedbackCount] = useState('');
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [subState, setSubState] = useState('...loading');

    const [isAdmin, setIsAdmin] = useState(false);
    const [adminId] = useState(localStorage.getItem('Admin'));
    const [teacherId] = useState(localStorage.getItem('teacher'));
    const [moduleName, setModuleName] = useState('...Loading');

    const [subscription, setSubscription] = useState('...Loading')
    const [hide, setHide] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const screeWidth = window.innerWidth;
            if (screeWidth < 768) {
                setHide(true);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        }

    }, [])

    const toggleSidebar = () => {
        setHide(prevHide => !prevHide); // Toggle the hide state
    };

    //Subcription
    const [formData] = useState({
        course_id: courseId,
        module_id: moduleId,
        student_id: userId,
        amount: price,
        exp_date: expDate()
    });

    const checkModuleName = async () => {
        try {
            const response = await fetch(`${API_URL}/modules/${moduleId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setModuleName(data[0].name);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
    }

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                const lessonResponse = await fetch(`${API_URL}/lessons/mod/${moduleId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const lesson = await lessonResponse.json();
                setLessonCount(lesson.length);
                setDataSource(lesson);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
            try {
                const assignmentResponse = await fetch(`${API_URL}/assignments/mod/${moduleId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const assignment = await assignmentResponse.json();
                setAssignmentCount(assignment.length);

                const noteResponse = await fetch(`${API_URL}/notes/mod/${moduleId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const note = await noteResponse.json();
                setNoteCount(note.length);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        const reg = "true"
        localStorage.setItem('sd', reg);

        checkModuleName();
        checkAdmin();
        expDate();
        fetchCounts();
    }, []);

    const functionLessons = () => {
        if (isSubscribed) {
            navigate('/lessons');
        } else {
            Swal.fire({
                text: "Subscribe to access this feature!",
                icon: "warning"
            });
        }
    }

    const functionAssignments = () => {
        if (isSubscribed) {
            navigate('/assignments');
        } else {
            Swal.fire({
                text: "Subscribe to access this feature!",
                icon: "warning"
            });
        }
    }

    const functionNotes = () => {
        if (isSubscribed) {
            navigate('/notes');
        } else {
            Swal.fire({
                text: "Subscribe to access this feature!",
                icon: "warning"
            });
        }
    }

    const functionResults = () => {
        if (isAdmin) {
            navigate('/results2');
        } else if (isSubscribed) {
            navigate('/results');
        } else {
            Swal.fire({
                text: "Subscribe to access this feature!",
                icon: "warning"
            });
        }
    }

    const functionFeedback = () => {
        // if (isAdmin) {
        //     navigate('/feedback2');
        // } else if (isSubscribed) {
        //     navigate('/feedback');
        // } else {
        //     Swal.fire({
        //         text: "Subscribe to access this feature!",
        //         icon: "warning"
        //     });
        // }

        // Temporary Suspension
        Swal.fire({
            text: "Feedback is not available at the moment!",
            icon: "info"
        });
    }

    const checkSub = async () => {

        //PROMO EDITION
        if (promo === 'true') {
            setIsSubscribed(true);
            // setSubscription('Promo Edition');
            // setSubState('You are on a promo edition, enjoy the features!');
            return;
        }

        try {
            const response = await fetch(`${API_URL}/subscriptions/student/${userId}/${courseId}/${getCurrentDate()}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data.length >= 1) {
                setIsSubscribed(true);
                setFreeTrial(false)
                setSubscription('Subscribed');
            } else {
                // setIsSubscribed(false);
                setSubscription('Not Subscribed')
                setSubState('Subscribe to access all the features')

                if (freeTrial) {
                    setIsSubscribed(true);
                    setSubscription('Free Trial');
                    setSubState('You are on a free trial, enjoy the features!');
                }

            }
            console.log(data.length);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
    };


    const checkAdmin = () => {
        // if (userId === adminId || userId === teacherId) {
        if ((localStorage.getItem('userRole') === "Admin") || userId === teacherId) {
            setIsAdmin(true);
            console.log(isAdmin);
            setIsSubscribed(true);
            setSubscription('Admin');

            const fetchCounts = async () => {
                try {

                    const resultResponse = await fetch(`${API_URL}/results/mod/${moduleId}/`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token()}`
                        }
                    });
                    const result = await resultResponse.json();
                    setResultCount(result.length);

                    const feedbackResponse = await fetch(`${API_URL}/feedback/marked/${moduleId}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token()}`
                        }
                    });
                    const feedback = await feedbackResponse.json();
                    setFeedbackCount(feedback.length);

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }

            fetchCounts();
        } else {
            checkSub();

            const fetchCounts = async () => {
                try {
                    const resultResponse = await fetch(`${API_URL}/results/mod/${moduleId}/${userId}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token()}`
                        }
                    });
                    const result = await resultResponse.json();
                    setResultCount(result.length);

                    const feedbackResponse = await fetch(`${API_URL}/feedback/marked/${moduleId}/${userId}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token()}`
                        }
                    });
                    const feedback = await feedbackResponse.json();
                    setFeedbackCount(feedback.length);

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
            fetchCounts();
        }
    };

    const handleSubscribers = () => {
        navigate('/subscribers');
    }

    const handleSubscribe = async () => {
        // e.preventDefault();

        setIsLoading(true);
        console.log(formData);

        window.location.href = `${API_URL}/initiate-payment/${formData.course_id}/${formData.module_id}/${formData.student_id}/${formData.amount}/${formData.exp_date}`;

        // const response = await fetch(`${API_URL}/initiate-payment/${formData.course_id}/${formData.module_id}/${formData.student_id}/${formData.amount}/${formData.exp_date}`, {
        //     method: 'GET',
        //     headers: { 'Content-Type': 'application/json' },
        // });

        // try {
        //     // Post results
        //     const response = await fetch(`${API_URL}/initiate-payment`, {
        //         method: 'GET',
        //         headers: { 'Content-Type': 'application/json' },
        //         // body: JSON.stringify(formData),
        //     });

        //     if (!response.ok) throw new Error('Subscription failed');
        // } catch (error) {
        //     Swal.fire({
        //         text: error.message || "An error occurred!",
        //         icon: "error"
        //     });
        // }
    }

    const handleConfirmSub = async (id) => {
        if (lessonCount < 1) {
            Swal.fire({
                text: "No lessons available, this module is not active.",
                icon: "info"
            });
            return;
        }
        const result = await Swal.fire({
            // title: 'Subscribe module',
            text: `The subscription is $${price} per month. You can pay using VISA, ECOCASH or INNBUCKS`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Subscribe!',
            cancelButtonText: 'Cancel!',
        });

        if (result.isConfirmed) {
            handleSubscribe();
        }
    };


    return (

        <html lang="en">

            <body id="page-top">

                <div id="wrapper">

                    <Sidebar hide={hide}></Sidebar>

                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content" style={{ backgroundColor: 'rgba(217, 224, 224, 0.863)' }}>

                            <Topnav title={moduleName} toggleSidebar={toggleSidebar}></Topnav>

                            <div className="container-fluid" style={{ textAlign: 'left', overflow: 'auto', maxHeight: '85vh', scrollbarWidth: 'none' }}>

                                {!isSubscribed ?
                                    <div>
                                        <h4>{subState}</h4>
                                    </div>
                                    : null}

                                <div className="cards">
                                    <div className="card-single">
                                        <div>
                                            <h2>{lessonCount}</h2>
                                            <span style={{ fontSize: '22px', fontWeight: 'bold' }}>Videos</span>
                                        </div>
                                        <div>
                                            {/* <span><img src="../../assets/Icons/BoardIcon.png" width="40px" height="40px" /></span> */}
                                            <span>
                                                <FontAwesomeIcon icon={faVideo} className="icon-xl" style={{ fontSize: '1.8rem', color: '#004d00' }} />
                                            </span>
                                            <div>
                                                <div>
                                                    <p></p>
                                                </div>
                                                <button className="bg-success btn-success" style={{borderColor:'#27ad54'}} onClick={functionLessons}>Enter<span></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-single">
                                        <div>
                                            <h2>{assignmentCount}</h2>
                                            <span style={{ fontSize: '22px', fontWeight: 'bold' }}>Assignments</span>
                                        </div>
                                        <div>
                                            {/* <span><img src="../../assets/Icons/BoardIcon.png" width="40px" height="40px" /></span> */}
                                            <span>
                                                <FontAwesomeIcon icon={faClipboardList} className="icon-xl" style={{ fontSize: '1.8rem', color: '#004d00' }} />
                                            </span>
                                            <div>
                                                <div>
                                                    <p></p>
                                                </div>
                                                <button className="bg-success btn-success" style={{borderColor:'#27ad54'}} onClick={functionAssignments}>Enter<span></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-single">
                                        <div>
                                            <h2>{noteCount}</h2>
                                            <span style={{ fontSize: '22px', fontWeight: 'bold' }}>Notes</span>
                                        </div>
                                        <div>
                                            {/* <span><img src="../../assets/Icons/BoardIcon.png" width="40px" height="40px" /></span> */}
                                            <span>
                                                <FontAwesomeIcon icon={faStickyNote} className="icon-xl" style={{ fontSize: '1.8rem', color: '#004d00' }} />
                                            </span>
                                            <div>
                                                <div>
                                                    <p></p>
                                                </div>
                                                <button className="bg-success btn-success" style={{borderColor:'#27ad54'}} onClick={functionNotes}>Enter<span></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-single">
                                        <div>
                                            <h2>{resultCount}</h2>
                                            <span style={{ fontSize: '22px', fontWeight: 'bold' }}>Results</span>
                                        </div>
                                        <div>
                                            {/* <span><img src="../../assets/Icons/BoardIcon.png" width="40px" height="40px" /></span> */}
                                            <span>
                                                <FontAwesomeIcon icon={faClipboardCheck} className="icon-xl" style={{ fontSize: '1.8rem', color: '#004d00' }} />
                                            </span>
                                            <div>
                                                <div>
                                                    <p></p>
                                                </div>
                                                <button className="bg-success btn-success" style={{borderColor:'#27ad54'}} onClick={functionResults}>Enter<span></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-single">
                                        <div>
                                            <h2>{feedbackCount}</h2>
                                            <span style={{ fontSize: '22px', fontWeight: 'bold' }}>Feedback</span>
                                        </div>
                                        <div>
                                            {/* <span><img src="../../assets/Icons/BoardIcon.png" width="40px" height="40px" /></span> */}
                                            <span>
                                                <FontAwesomeIcon icon={faClipboardList} className="icon-xl" style={{ fontSize: '1.8rem', color: '#004d00' }} />
                                            </span>
                                            <div>
                                                <div>
                                                    <p></p>
                                                </div>
                                                <button className="bg-success btn-success" style={{borderColor:'#27ad54'}} onClick={functionFeedback}>Enter<span></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-single">
                                        <div>
                                            <h4 style={{ fontSize: '25px', fontWeight: 'lighter' }}>{subscription}</h4> <p></p>
                                            <span style={{ fontSize: '22px', fontWeight: 'bold' }}>Subscription</span>
                                        </div>
                                        <div>
                                            {/* <span><img src="../../assets/Icons/BoardIcon.png" width="40px" height="40px" /></span> */}
                                            <span>
                                                <FontAwesomeIcon icon={faUsers} className="icon-xl" style={{ fontSize: '1.8rem', color: '#004d00' }} />
                                            </span>
                                            <div>
                                                <div>
                                                    <p></p>
                                                </div>

                                                {(() => {
                                                    if (isLoading) {
                                                        return (
                                                            <div style={{ marginTop: '8px', textAlign: 'center' }}>
                                                                <div className="btn" style={{ width: '5rem' }}>
                                                                    <ClipLoader loading={isLoading} size={27} color="white" />
                                                                </div>
                                                            </div>
                                                        );
                                                    }

                                                    if (isAdmin) {
                                                        return (
                                                            <button onClick={handleSubscribers} style={{ backgroundColor: 'white', color: '#675dc5', borderColor: '#675dc5' }}>
                                                                Subscribers<span></span>
                                                            </button>
                                                        );
                                                    }

                                                    if (isSubscribed) {
                                                        return (
                                                            <button style={{ backgroundColor: 'white', color: '#5dc574', borderColor: '#5dc574' }}>
                                                                {freeTrial ? 'Free Trial Active' : 'Subscribed'}<span></span>
                                                            </button>
                                                        );
                                                    }

                                                    return (
                                                        <button onClick={handleConfirmSub} style={{ backgroundColor: 'white', color: '#675dc5', borderColor: '#675dc5' }}>
                                                            Subscribe<span></span>
                                                        </button>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{ width: '100%', marginTop: '20px' }}>
                                    <div className="topics-grid">
                                        <div className="none">
                                            <div className="Projects">
                                                <div className="card" style={{ minHeight: '8rem' }}>
                                                    <div className="card-header">
                                                        <h3 style={{ fontSize: '30px', fontWeight: 'bold' }}>Lessons Available</h3>
                                                        <button
                                                            style={{ backgroundColor: '#27ad54', borderColor: '#27ad54' }}>See
                                                            All<span className="las la-arrow-right"></span></button>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="table-responsive">
                                                            <table className="table" id="dataTable" width="100%" cellspacing="0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Lesson No</th>
                                                                        <th>Topic</th>
                                                                        <th>Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {dataSource.map((element) => (
                                                                        <tr key={element.lesson_id}>
                                                                            <td>{element.lesson_no} </td>
                                                                            <td>{element.topic}</td>
                                                                            <td>Available</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="notifications-grid">
                                        <div >
                                            <div className="card">
                                                <div className="card-header">
                                                    <h3 style={{ fontSize: '20px', fontWeight: 'bold' }}>Notifications</h3>
                                                    <button style={{ backgroundColor: '#27ad54', borderColor: '#27ad54' }}>See All<span
                                                        className="las la-arrow-right"></span></button>
                                                </div>
                                                <div className="card-body">
                                                    <div className="customer">
                                                        <h4 style={{ padding: '5px', fontSize: '17px' }}>No Notifications Available</h4>
                                                    </div>

                                                    <div>
                                                        <span className="las la-user-circle"></span>
                                                        <span className="las la-user-comment"></span>
                                                        <span className="las la-user-phone"></span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {/* Submit Assignment Modal
                {showAddModal && (
                    <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowAddModal(false)}>
                        <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content" style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
                                <div className="modal-header">
                                    <h5 className="modal-title">Subscription</h5>
                                    <button type="button" className="close" onClick={() => setShowAddModal(false)}>&times;</button>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Close</button>
                                        <button type="submit" className="btn btn-primary">Subscribe</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
 */}

            </body>

        </html >
    );
};

export default StudentHome;